module.exports = __webpack_public_path__ + "media/customizations/heritagelife/logo-7326a269d9199f2c5a8d506f9ca8c000.png";